// 1st code

// import { DatePicker, Form } from 'antd';
// import { filterData, setFilterData } from 'common/commonRedux/feature/filteringSlice';
// import dayjs, { Dayjs } from 'dayjs';
// import { useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';

// const { RangePicker } = DatePicker;

// interface TDateSelect {
//   isOnlyMonth?: boolean;
// }

// export const DateSelect = ({ isOnlyMonth }: TDateSelect) => {
//   const [isPickerOpen, setIsPickerOpen] = useState(false);
//   const getFilterData = useSelector(filterData)
//   const dispatch = useDispatch()
//   return (
//     <Form.Item noStyle shouldUpdate>
//       {() => {
//         return (
//           <div className="relative w-full">
//             <div className="flex items-center gap-[7px] w-full">
//               {isOnlyMonth ? (
//                 <DatePicker
//                   value={getFilterData?.month}
//                   onChange={(date: Dayjs | null) => {
//                     if (!date) {
//                       // resetState()
//                       dispatch(setFilterData({ month: dayjs() }))
//                     } else {
//                       // resetState()
//                       dispatch(setFilterData({ month: date }))
//                     }
//                   }}
//                   picker="month"
//                   disabledDate={(current) => current && current.isAfter(dayjs(), 'month')}
//                   allowClear={true}
//                   style={{
//                     height: 35,
//                     borderRadius: 8,
//                     borderColor: '#D7D7D7',
//                   }}
//                   className="md:w-[180px] w-full"
//                 />
//               ) : (
//                 <RangePicker
//                   open={isPickerOpen}
//                   value={ getFilterData?.dateRange}
//                   onChange={(dates: [Dayjs | null, Dayjs | null] | null) => {
//                     if (!dates) {
//                       if (getFilterData.isSingleDate) {
//                         // resetState()
//                         dispatch(setFilterData({ singleDate: [dayjs(), dayjs()] }))
//                       }
//                       // resetState()
//                       dispatch(setFilterData({ dateRange: [dayjs().subtract(1, 'week'), dayjs()], }))
//                     } else {
//                       if (getFilterData.isSingleDate) {
//                          dispatch(setFilterData({ singleDate: dates }))
//                       }
//                       dispatch(setFilterData({ dateRange: dates }))
//                     }
//                   }}
//                   onOpenChange={() => setIsPickerOpen(!isPickerOpen)}
//                   format="MMM DD"
//                   className="w-full md:w-[250px]"
//                   style={{ height: 35 }}
//                   popupClassName="w-[280px] md:w-full"
//                 />
//               )}
//             </div>
//           </div>
//         );
//       }}
//     </Form.Item>
//   );
// };

// 2nd code

import { DatePicker, Form } from 'antd';
import {
  filterData,
  setFilterData,
} from 'common/commonRedux/feature/filteringSlice';
import { RootState } from 'common/redux/store';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DateSelect.css';
const { RangePicker } = DatePicker;

interface TDateSelect {
  isOnlyMonth?: boolean;
  isProjectDateRange?: boolean;
}

export const DateSelect = ({
  isOnlyMonth,
  isProjectDateRange = false,
}: TDateSelect) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const getFilterData = useSelector(filterData);
  const { format } = useSelector((state: RootState) => state.dateFormatter);
  const dispatch = useDispatch();

  return (
    <div className="filtering-date-select">
      <Form.Item noStyle shouldUpdate>
        {() => (
          <div className="relative w-full">
            <div className="flex items-center gap-[7px] w-full">
              {isOnlyMonth ? (
                <DatePicker
                
                  format={format}
                  value={getFilterData?.month}
                  onChange={(date: Dayjs | null) => {
                    if (!date) {
                      dispatch(
                        setFilterData({
                          month: dayjs().add(6, 'hour'),
                          pageNumber: 1,
                        })
                      );
                    } else {
                      dispatch(
                        setFilterData({
                          month: date.add(6, 'hour'),
                          pageNumber: 1,
                        })
                      );
                    }
                  }}
                  picker="month"
                  disabledDate={(current) => {
                    return current && current.isAfter(dayjs(), 'month');
                  }}
                  allowClear={true}
                  style={{
                    // height: 44,
                    // borderRadius: 10,
                    borderColor: '#E5E7EB',
                  }}
                  className="md:w-[240px] h-[36px] rounded-[4px] w-full"
                  popupClassName="filtering-top-bar-dropdown"
                />
              ) : (
                <>
                  {isProjectDateRange ? (
                    <RangePicker
                      open={isPickerOpen}
                      value={getFilterData?.projectDateRange}
                      onChange={(
                        dates: [Dayjs | null, Dayjs | null] | null
                      ) => {
                        if (!dates) {
                          const defaultStart = null;
                          const defaultEnd = null;
                          if (getFilterData.isSingleDate) {
                            dispatch(
                              setFilterData({
                                singleDate: [defaultEnd, defaultEnd],
                                pageNumber: 1,
                              })
                            );
                          }
                          dispatch(
                            setFilterData({
                              projectDateRange: [defaultStart, defaultEnd],
                              pageNumber: 1,
                            })
                          );
                        } else {
                          const adjustedDates: [Dayjs, Dayjs] = [
                            dates[0]?.add(6, 'hour') as Dayjs,
                            dates[1]?.add(6, 'hour') as Dayjs,
                          ];
                          if (getFilterData.isSingleDate) {
                            dispatch(
                              setFilterData({
                                singleDate: adjustedDates,
                                pageNumber: 1,
                              })
                            );
                          }
                          dispatch(
                            setFilterData({
                              projectDateRange: adjustedDates,
                              pageNumber: 1,
                            })
                          );
                        }
                      }}
                      onOpenChange={() => setIsPickerOpen(!isPickerOpen)}
                      format={format}
                      className="w-full md:w-[240px] rounded-[4px] "
                      style={{ height: 36, width: '100%', borderRadius: 4 }}
                      popupClassName="filtering-top-bar-dropdown"
                      
                    />
                  ) : (
                    <RangePicker
                      open={isPickerOpen}
                      value={getFilterData?.dateRange}
                      onChange={(
                        dates: [Dayjs | null, Dayjs | null] | null
                      ) => {
                        if (!dates) {
                          const defaultStart = dayjs()
                            .subtract(1, 'week')
                            .add(6, 'hour');
                          const defaultEnd = dayjs().add(6, 'hour');
                          if (getFilterData.isSingleDate) {
                            dispatch(
                              setFilterData({
                                singleDate: [defaultEnd, defaultEnd],
                                pageNumber: 1,
                              })
                            );
                          }
                          dispatch(
                            setFilterData({
                              dateRange: [defaultStart, defaultEnd],
                              pageNumber: 1,
                            })
                          );
                        } else {
                          const adjustedDates: [Dayjs, Dayjs] = [
                            dates[0]?.add(6, 'hour') as Dayjs,
                            dates[1]?.add(6, 'hour') as Dayjs,
                          ];
                          if (getFilterData.isSingleDate) {
                            dispatch(
                              setFilterData({
                                singleDate: adjustedDates,
                                pageNumber: 1,
                              })
                            );
                          }
                          dispatch(
                            setFilterData({
                              dateRange: adjustedDates,
                              pageNumber: 1,
                            })
                          );
                        }
                      }}
                      onOpenChange={() => setIsPickerOpen(!isPickerOpen)}
                      format={format}
                      className="w-full md:w-[240px] rounded-[4px] "
                      style={{ height: 36, width: '100%', borderRadius: 4 }}
                      disabledDate={(current) => {
                        // Can not select days after today
                        return current && current > dayjs().endOf('day');
                      }}
                      popupClassName="filtering-top-bar-dropdown"
                    />
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </Form.Item>
    </div>
  );
};

//  3rd code

// import { DatePicker, Form } from 'antd';
// import { filterData, setFilterData } from 'common/commonRedux/feature/filteringSlice';
// import dayjs, { Dayjs } from 'dayjs';
// import utc from 'dayjs/plugin/utc';
// import { useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';

// dayjs.extend(utc); // enable UTC plugin

// const { RangePicker } = DatePicker;

// interface TDateSelect {
//   isOnlyMonth?: boolean;
// }

// export const DateSelect = ({ isOnlyMonth }: TDateSelect) => {
//   const [isPickerOpen, setIsPickerOpen] = useState(false);
//   const getFilterData = useSelector(filterData);
//   const dispatch = useDispatch();

//   return (
//     <Form.Item noStyle shouldUpdate>
//       {() => {
//         return (
//           <div className="relative w-full">
//             <div className="flex items-center gap-[7px] w-full">
//               {isOnlyMonth ? (
//                 <DatePicker
//                   value={getFilterData?.month}
//                   onChange={(date: Dayjs | null) => {
//                     const selectedDate = date ? dayjs(date) : dayjs();

//                     console.log('Selected Month - Local Time:', selectedDate.format());
//                     console.log('Selected Month - UTC Time:', selectedDate.utc().format());

//                     dispatch(setFilterData({ month: selectedDate }));
//                   }}
//                   picker="month"
//                   disabledDate={(current) => current && current.isAfter(dayjs(), 'month')}
//                   allowClear={true}
//                   style={{
//                     height: 35,
//                     borderRadius: 8,
//                     borderColor: '#D7D7D7',
//                   }}
//                   className="md:w-[180px] w-full"
//                 />
//               ) : (
//                 <RangePicker
//                   open={isPickerOpen}
//                   value={getFilterData?.dateRange}
//                   onChange={(dates: [Dayjs | null, Dayjs | null] | null) => {
//                     const from = dates?.[0] || dayjs().subtract(1, 'week');
//                     const to = dates?.[1] || dayjs();

//                     console.log('Selected From - Local Time:', from.format());
//                     console.log('Selected From - UTC Time:', from.utc().format());
//                     console.log('Selected To - Local Time:', to.format());
//                     console.log('Selected To - UTC Time:', to.utc().format());

//                       console.log('From Local Timestamp:', from.valueOf());
//                       console.log('From UTC Timestamp:', from.utc().valueOf());
//                       console.log('To Local Timestamp:', to.valueOf());
//                       console.log('To UTC Timestamp:', to.utc().valueOf());

//                     if (!dates) {
//                       if (getFilterData.isSingleDate) {
//                         dispatch(setFilterData({ singleDate: [dayjs(), dayjs()] }));
//                       }
//                       dispatch(setFilterData({ dateRange: [from, to] }));
//                     } else {
//                       if (getFilterData.isSingleDate) {
//                         dispatch(setFilterData({ singleDate: dates }));
//                       }
//                       dispatch(setFilterData({ dateRange: dates }));
//                     }
//                   }}
//                   onOpenChange={() => setIsPickerOpen(!isPickerOpen)}
//                   format="MMM DD"
//                   className="w-full md:w-[250px]"
//                   style={{ height: 35 }}
//                   popupClassName="w-[280px] md:w-full"
//                 />
//               )}
//             </div>
//           </div>
//         );
//       }}
//     </Form.Item>
//   );
// };
